import { render, staticRenderFns } from "./onlyoffice-editor.vue?vue&type=template&id=eacaba20&"
import script from "./onlyoffice-editor.vue?vue&type=script&lang=js&"
export * from "./onlyoffice-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_geeguvfn2njjaew5w23blzhalq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports